import { isSonoraMentionsPluginFileSuggestionsEnabled } from 'owa-editor-sonora-common/lib/utils/file/isSonoraPluginFileSuggestionsEnabled';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isSonoraMentionsPluginEnabled(): boolean {
    return (
        isFeatureEnabled('honeybee-sonora') &&
        isFeatureEnabled('honeybee-sonora-mentions-plugin') &&
        isSonoraMentionsPluginFileSuggestionsEnabled()
    );
}

export function isSonoraMentionsPluginEnabledForCalendar(): boolean {
    return (
        isFeatureEnabled('honeybee-sonora') &&
        isFeatureEnabled('honeybee-sonora-mentions-plugin-calendar') &&
        isSonoraMentionsPluginFileSuggestionsEnabled()
    );
}
